import { Injectable } from '@angular/core';
import { Entity, Enum } from '@app/app.model';
import { Observable, BehaviorSubject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { environment as e } from 'src/environments/environment';
import { Customer, CustomerInterface } from './customer.model';
import { ErrorsService } from '@app/_shared/errors/errors.service';

@Injectable({
    providedIn: 'root'
})
export class CustomerService implements CustomerInterface {

    constructor(private _http: HttpClient, private errors$: ErrorsService) { }
    
    private listRetrieved: BehaviorSubject<Customer[]> = new BehaviorSubject<Customer[]>(undefined);
    ListRetrieved = this.listRetrieved.asObservable();
    notifyRetrieved(data: Customer[]): void {
        this.listRetrieved.next(data);
    }

    save: (data: Entity<Customer>) => Observable<any>;

    getEntity(param: any): Observable<Customer> {
        return this._http.get<Customer>(e.endpoint.customers.customer + "/" + param.Id + "/" + param.Position)
        .pipe(catchError(this.errors$.handleNetworkError));
    }

    create(data: Entity<Customer>): Observable<any> {
        return this._http.put<Customer>(
            e.endpoint.customers.customer + "/" + data.value.originalId + "/" + data.value.originalPos,
            data.value).pipe(catchError(this.errors$.handleNetworkError));
    }

    getList(param): Observable<Customer[]> {
        return this._http.put<Customer[]>(e.endpoint.customers.customer + '/filter/', param)
        .pipe(catchError(this.errors$.handleNetworkError));
    }

    delete(param: any): Observable<any> {
        return this._http.delete(e.endpoint.customers.customer + '/' + param.Id + "/" + param.Position, {
            responseType: "text"
        },).pipe(catchError(this.errors$.handleNetworkError));
    }

    getNewEntity(): Observable<Customer> {
        return this._http.get<Customer>(e.endpoint.customers.customer + '/newcustomer')
        .pipe(catchError(this.errors$.handleNetworkError));
    }


    getBillingCustomers(param): Observable<Customer[]> {
        return this._http.put<Customer[]>(e.endpoint.customers.customer + '/billingcustomer/', param)
        .pipe(catchError(this.errors$.handleNetworkError));
    }

    getPaymentTermList(companyId): Observable<Enum[]> {
        if (companyId == null) companyId = 0;
        return this._http.get<Enum[]>(e.endpoint.paymentTerms + '/paymentterms/' + companyId + '/1')
        .pipe(catchError(this.errors$.handleNetworkError));
    }

    getSpecialPriceGroupList(): Observable<Enum[]> {
        return this._http.get<Enum[]>(e.endpoint.customers.specialPriceGroup + '/1')
        .pipe(catchError(this.errors$.handleNetworkError));
    }

    getProductList(groupId): Observable<Enum[]> {
        return this._http.get<Enum[]>(e.endpoint.products.product + '/withgroupspecialprices/' + groupId)
        .pipe(catchError(this.errors$.handleNetworkError));
    }
    getProductDropdown(): Observable<Enum[]> {
        return this._http.get<Enum[]>(e.endpoint.products.product + '/dropdown/0')
        .pipe(catchError(this.errors$.handleNetworkError));
    }

    getLastDeliveryLocationById(customerId, position): Observable<Enum[]> {
        return this._http.get<Enum[]>(e.endpoint.unloadPoint + "/lastDeliveryLocation/" + customerId + "/" + position)
        .pipe(catchError(this.errors$.handleNetworkError));
    }

    getBillQuantityTypeList(): Observable<Enum[]> {
        return this._http.get<Enum[]>(e.endpoint.customers.customer + "/GetBillQuantityTypeList")
        .pipe(catchError(this.errors$.handleNetworkError));
    }


    getAutoEmailOptionsList(): Observable<Enum[]> {
        return this._http.get<Enum[]>(e.endpoint.customers.customer + "/GetAutoEmailOptionsList")
        .pipe(catchError(this.errors$.handleNetworkError));
    }
    getSignatureSettingsOptionList(): Observable<Enum[]> {
        return this._http.get<Enum[]>(e.endpoint.customers.customer + "/SignatureSettingsOptionList")
        .pipe(catchError(this.errors$.handleNetworkError));
    }

    getProductOptions(): Observable<Enum[]> {
        return this._http.get<Enum[]>(e.endpoint.customers.customer + "/ProductOptions")
        .pipe(catchError(this.errors$.handleNetworkError));
    }
    getPrintOptions(): Observable<Enum[]> {
        return this._http.get<Enum[]>(e.endpoint.customers.customer + "/PrintOptions")
        .pipe(catchError(this.errors$.handleNetworkError));
    }
    getStrappingChartProfile(): Observable<Enum[]> {
        return this._http.get<Enum[]>(e.endpoint.strappingChartProfiles + "/list")
        .pipe(catchError(this.errors$.handleNetworkError));
    }
    getDippingType(): Observable<Enum[]> {
        return this._http.get<Enum[]>(e.endpoint.unloadPoint + "/getUnloadPointDippingTypes")
        .pipe(catchError(this.errors$.handleNetworkError));
    }

}